import { getAppSetting } from '../ApplicationSettings';

const IDENTITY_CONFIG = {
  authority: getAppSetting('REACT_APP_AUTH_URL') + '/', //(string): The URL of the OIDC provider.
  client_id: getAppSetting('REACT_APP_IDENTITY_CLIENT_ID'), //(string): Your client application's identifier as registered with the OIDC provider.
  client_secret: 'notasecret',
  redirect_uri: location.origin + '/auth/signin-oidc', //The URI of your client application to receive a response from the OIDC provider.
  automaticSilentRenew: true, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
  //silent_redirect_uri: getAppSetting('REACT_APP_PUBLIC_URL') + '/auth/silentrenew', //(string): The URL for the page containing the code handling the silent renew.
  post_logout_redirect_uri: location.origin, // (string): The OIDC post-logout redirect URI.
  response_type: 'code', //(string, default: 'id_token'): The type of response desired from the OIDC provider.
  scope: 'openid ibinder_public offline_access profile', //(string, default: 'openid'): The scope being requested from the OIDC provider.
  revokeAccessTokenOnSignout: false,
  monitorSession: false
};

const METADATA_OIDC = {
  issuer: getAppSetting('REACT_APP_AUTH_URL'),
  jwks_uri:
    getAppSetting('REACT_APP_AUTH_URL') +
    '/.well-known/openid-configuration/jwks',
  authorization_endpoint:
    getAppSetting('REACT_APP_AUTH_URL') + '/connect/authorize',
  token_endpoint: getAppSetting('REACT_APP_AUTH_URL') + '/connect/token',
  userinfo_endpoint: getAppSetting('REACT_APP_AUTH_URL') + '/connect/userinfo',
  end_session_endpoint:
    getAppSetting('REACT_APP_AUTH_URL') + '/connect/endsession',
  check_session_iframe:
    getAppSetting('REACT_APP_AUTH_URL') + '/connect/checksession',
  revocation_endpoint:
    getAppSetting('REACT_APP_AUTH_URL') + '/connect/revocation',
  introspection_endpoint:
    getAppSetting('REACT_APP_AUTH_URL') + '/connect/introspect'
};

export default { IDENTITY_CONFIG, METADATA_OIDC };
